import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import * as api from 'api/methods';

import { useFetch } from 'hooks/useFetch';

import { COURSE_TYPES } from 'constants/common';

import { convertDataToApi } from './CreateCourse.helpers';

import CreateCourse from './CreateCourse';

const CreateCourseContainer = ({
  open,
  type,
  ...restProps
}: { open: any; type: any } & Record<string, any>) => {
  const navigate = useNavigate();

  const [createLoading, setCreateLoading] = useState(false);

  const { data: schools } = useFetch(
    {
      defaultData: [],
      fetcher: api.getSchools,
      immediately: false,
      stopRequest: !open,
    },
    null,
    [open],
  );

  const handleCreateClick = async (
    values: any,
    { resetForm }: { resetForm: any },
  ) => {
    setCreateLoading(true);

    try {
      const course = await api.createCourse(convertDataToApi(values, type));

      resetForm();

      if (type === COURSE_TYPES.LEARNING_PATH) {
        navigate(`/learning-path/courses/${course.id}`);
      } else {
        navigate(`/courses/${course.id}`);
      }
    } catch (error) {
      console.warn(error); // TODO: catch error
    }

    setCreateLoading(false);
  };

  const schoolOptions = schools.map((school: any) => ({
    label: `${school.name} (${school.language})`,
    value: school.id,
  }));

  return (
    <CreateCourse
      {...restProps}
      open={open}
      createLoading={createLoading}
      schoolOptions={schoolOptions}
      onCreateClick={handleCreateClick}
    />
  );
};

export default React.memo(CreateCourseContainer) as any;
